import { ToastManager } from '../../ToastManager';

import { useI18n } from '../../hooks/useI18nFormatters';

import { cssClass } from '../../theme/cssClass';
import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';

import { GradientButtonRound } from '../../components/buttons/GradientButtonRound';
import { MonoButtonRound } from '../../components/buttons/MonoButtonRound';
import { HeaderActionsContainer } from '../../components/header/HeaderActionsContainer';

import { scriptsStore } from './ScriptsStore';
import { useScriptRouteId } from './useScriptRouteId';
import { useScript } from './useScripts';

export function ScriptActions(props) {
  const { scriptRouteId } = useScriptRouteId();
  const { script } = useScript({ scriptId: scriptRouteId });
  const { i18n } = useI18n();

  function handleRequestSaveScript() {
    if (script?.code == null) {
      return;
    }

    scriptsStore
      .updateScript({
        id: scriptRouteId,
        script: {
          code: props.editorInstanceRef.current?.getValue(),
        },
      })
      .then((script) => {
        ToastManager.add({
          icon: glyph.core.paper,
          i18n: {
            key: 'script.savedMessage',
            props: { name: script.name },
          },
        });
      })
      .catch(ToastManager.handleError);
  }

  function handleRequestTestScript() {
    if (script?.code == null) {
      return;
    }

    scriptsStore
      .testScript({
        id: scriptRouteId,
        script: {
          code: props.editorInstanceRef.current?.getValue(),
        },
      })
      .catch(ToastManager.handleError);
  }

  return (
    <HeaderActionsContainer>
      <GradientButtonRound isDisabled={script?.code == null} onPress={handleRequestSaveScript}>
        <GradientButtonRound.Icon
          source={glyph.core.checkmark}
          size={theme.icon.size_default}
          color={theme.color.white}
        />
        <GradientButtonRound.Text className={cssClass.showForLarge}>
          {i18n.messageFormatter('common.save')}
        </GradientButtonRound.Text>
      </GradientButtonRound>
      <MonoButtonRound
        styleIconColor="green"
        isDisabled={script?.code == null}
        onPress={handleRequestTestScript}
      >
        <MonoButtonRound.Icon source={glyph.core.play} size={theme.icon.size_default} />
        <MonoButtonRound.Text className={cssClass.showForLarge}>
          {i18n.messageFormatter('common.test')}
        </MonoButtonRound.Text>
      </MonoButtonRound>
    </HeaderActionsContainer>
  );
}
